module.exports = __webpack_public_path__ + "img/Z85-X18-中_02.4ff8489a.jpg";